<template>
    <div id="wrapper">
      <nhan-su-side-bar index="6"></nhan-su-side-bar>
  
      <div id="content-wrapper" class="page">
        <div class="container-fluid">
          <span style="display: inline;">
              <button class="btn btn-info mb-2" @click.prevent="openAddBankModal">
                <i class="fas fa-plus"></i> Add new record
              </button>
              <b-table
              id="my-table"
              bordered
              head-variant="dark"
              hover
              responsive
              striped
              small
              table-variant="light"
              :fields="Fields"
              :items="banks"
            >
              <template v-slot:cell(action)="data">
                <b-link class="text-primary mr-2" href="#" @click="openUpdateBankModal(data.item)">
                  <i class="fas fa-pencil-alt"></i>
                </b-link>
                <b-link class="text-danger" href="#" @click.prevent="deleteBank(data)">
                  <i class="fas fa-trash"></i>
                </b-link>
              </template>
            </b-table>
            </span>
        </div>
  
        <!-- BANK MODAL -->
        <b-modal
          v-model="bankModalShow"
          size="xl"
          header-bg-variant="info"
          header-text-variant="light"
          @hidden="closeBankModal"
          hide-footer
          >
          <template v-if="!isUpdating" v-slot:modal-title>
            <div >Add new record</div>
          </template>
          <template v-else v-slot:modal-title>
            <div >Update record</div>
          </template>
          <b-form autocomplete="off">
            <b-row>
            <b-col>
              <b-form-group>
                <template v-slot:label>Name <code>*</code> </template>
                <b-row>
                  <b-col>
                    <b-form-select v-model="Item.name" 
                    
                      oninput="setCustomValidity('')" required>
                      <b-form-select-option value="Vietnam">Vietnam</b-form-select-option>
                      <b-form-select-option value="Expat">Expat</b-form-select-option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
            <!-- <b-row>
            <b-col>
              <b-form-group>
                <template v-slot:label>Name <code>*</code> </template>
                <b-form-input v-model="Item.name" id="textarea-auto-height"
                  placeholder="Please write down the name">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col>
              <b-form-group>
                <template v-slot:label>Value <code>*</code> </template>
                <b-form-input v-model="Item.number" id="textarea-auto-height"
                  placeholder="" type="number">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
            <b-row>
            <b-col style="margin-bottom: -15px">
              <b-form-group>
                <template v-slot:label> Effect <code>*</code> </template>
                <!-- <b-form-input  size="sm" v-model="contract.signingDate" type="date" /> -->
                <my-date-picker v-model="Item.effect"
                  placeholder="Please select the date the Effect has been received - DD/MM/YYYY" required></my-date-picker>
  
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="margin-bottom: -15px">
              <b-form-group>
                <template v-slot:label> Expired  </template>
                <!-- <b-form-input  size="sm" v-model="contract.signingDate" type="date" /> -->
                <my-date-picker v-model="Item.expired"
                  placeholder="Please select the date the Expired has been received - DD/MM/YYYY" required></my-date-picker>
  
              </b-form-group>
            </b-col>
          </b-row>
            <b-row>
              <b-col cols="12">
                <b-button variant="info" v-if="!isUpdating" @click="storeBank" style="float:right;">
                  <i class="fas fa-save mr-2"></i>Lưu
                </b-button>
                <b-button variant="info" v-else @click="updateBank" style="float:right;">
                  <i class="fas fa-save mr-2"></i>Lưu
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-modal>
        <!-- END OF BANK MODAL -->
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import NhanSuSideBar from "../components/NhanSu/NhanSuSideBar";
  import MyDatePicker from "../components/App/DatePickerUS";
  export default {
    name: "Banks",
    components: {
      NhanSuSideBar,
      MyDatePicker
    },
    data() {
      return {
        Fields: [
          {
            key: "name",
            label: "Name",
          },
          {
            key: "number",
            label: "Value",
          },
          {
            key: "effect",
            label: "Effect",
            formatter: 'convertDate',
          },
          {
            key: "expired",
            label: "Expired",
            formatter: 'convertDate',
          },
          {
            key: "notes",
            label: "Notes",
          },
          {
            key: "action",
            label: "",
            thStyle: { width: "50px !important" },
          },
        ],
        Fields2: [
          {
            key: "name",
            label: "Name",
          },
          {
            key: "number",
            label: "Value",
          },
          {
            key: "effect",
            label: "Effect",
            formatter: 'convertDate',
          },
          {
            key: "expired",
            label: "Expired",
            formatter: 'convertDate',
          },
          {
            key: "notes",
            label: "Notes",
          },
          {
            key: "action",
            label: "",
            thStyle: { width: "50px !important" },
          },
        ],
        banks: [],
        Item: {
          id: 0,
          name: "",
          number: 0,
          effect: null,
          expired : null,
          notes : "",
        },
        bankModalShow: false,
        isUpdating: false,
      }
    },
    beforeRouteEnter(to, from, next) {
      axios
      .all([
        axios.get("/api/value/getAllValue"),
      ])
      .then(
        axios.spread((bank) => {
            next((vm) => vm.initData(bank.data));
          }
        )
      );
    },
    methods: {
      initData(banks) {
        this.banks = banks;
      },
      openAddBankModal() {
        this.bankModalShow = true;
      },
      closeBankModal() {
        this.Item.id = 0;
        this.Item.name = "";
        this.Item.number = null;
        this.Item.effect = null;
        this.Item.expired = null,
        this.bankModalShow = false;
        this.isUpdating = false;
      },
      openUpdateBankModal(data) {

        this.bankModalShow = true;
        this.isUpdating = true;
        this.Item.id = data.id;
        this.Item.number = data.number;
        this.Item.name = data.name;
        this.Item.effect = this.$convert_date_string(data.effect);
        this.Item.expired = this.$convert_date_string(data.expired);

  
      },
      storeBank() {
        const v = {
            id : this.Item.id,
            name : this.Item.name,
            number : parseFloat(this.Item.number),
            effect : this.$convert_string_date_special(this.Item.effect),
            expired : this.$convert_string_date_special(this.Item.expired),
            notes : this.Item.notes,
        };
        this.$log("kok");
        this.$log(v);
        if (this.Item.name == "" || this.Item.number == null || this.Item.number == "" || this.Item.effect == null) {this.$toast.error("Vui lòng điền đầy đủ thông tin", "Lỗi", { timeout: 3000 }); return;}
        axios.post("/api/value/post", v)
             .then((res) => {this.banks.push(res.data); this.closeBankModal();})
             .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });})
      },
      updateBank() {
        const v = {
            id : this.Item.id,
            name : this.Item.name,
            number : parseFloat(this.Item.number),
            effect : this.$convert_string_date_special(this.Item.effect),
            expired : this.$convert_string_date_special(this.Item.expired),
            notes : this.Item.notes,
        };
        this.$log("kok");
        this.$log(v);
        if (this.Item.name == "" || this.Item.number == null || this.Item.number == "" || this.Item.effect == null) {this.$toast.error("Vui lòng điền đầy đủ thông tin", "Lỗi", { timeout: 3000 }); return;}
        axios.put("/api/value/update", v)
             .then((res) => {
               this.banks = this.$insert_array_parse_json(res.data, this.banks);
               this.closeBankModal();
              })
             .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });})
      },
      convertDate(value) {
        return this.$convert_date_string(value);
      },
      deleteBank(data) {
        this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {timeout: 20000, close: false, overlay: true, displayMode: "once", position: "center",
          buttons: [
            ["<button><b>Có</b></button>", (instance, toast) => {
                axios
                  .delete(`/api/value/delete/${data.item.id}`)
                  .then((res) => {this.banks.splice(data.index, 1);})
                  .catch((err) => {this.$toast.error(err.response.data, "Lỗi", {timeout: 3000,});});
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
              },
              true,
            ],
            ["<button>Không</button>", function (instance, toast) {
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
              },
            ],
          ],
        });
      },
    }
  
  }
  </script>